<template>
  <div>
    <h3>{{ $t("navigation." + constants.ROUTE_NEW_CATEGORY) }}</h3>
    <CategoryForm @categorySubmitted="createCategory" />
  </div>
</template>

<script>
import * as constants from "./../../constants";
import CategoryForm from "./CategoryForm";

export default {
  name: "NewCategory",
  data() {
    return {
      constants
    };
  },
  components: { CategoryForm },
  methods: {
    createCategory() {
      this.$router.push({
        name: constants.ROUTE_CATEGORIES,
        params: { forceReload: true }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("changeBg");
    next();
  }
};
</script>

<style scoped></style>
